@if (isLink()) {
  <a class="cursor-pointer text-blue-600" (click)="onLinkClick($event)">{{
    value()
  }}</a>
} @else {
  {{ value() }}
}
